import { Interpolation, Theme, css } from '@emotion/react';
import { FirstWordBoldText } from '@frontend/grid-dashboard';
import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { Photos } from '@frontend/photos';
import { theme } from '@frontend/theme';
import { Chip, Text, Truncated } from '@frontend/design-system';
import { ColorDot } from './color-dot';

// TODO: remove this once integrated with real data
const APPOINTMENT_INFO = {
  locationId: 'loc-001',
  personId: '12345',
  personName: 'Bridget Holstrom',
  appointmentTime: '10:30 AM (60 Mins)',
  appointmentType: 'Summer Body Package',
  providerName: 'Dr. Amanda Bynes',
  operatoryName: 'Exam Room 5',
  statusColor: '#89E1DB',
};

interface AppointmentListItemProps {
  as?: React.ElementType;
  containerCss?: Interpolation<Theme>;
}

export const AppointmentListItem = ({ as: Component = 'section', containerCss }: AppointmentListItemProps) => {
  const { t } = useTranslation('schedule');

  return (
    <Component css={[mainContainer, containerCss]}>
      <Photos.ContactProfilePhoto
        size='small'
        personId={APPOINTMENT_INFO.personId}
        name={APPOINTMENT_INFO.personName}
        // TODO: integrate click handler
        onClick={() => console.log('Open Contact Panel')}
      />
      <div css={{ flex: 1, display: 'flex', flexDirection: 'column', gap: theme.spacing(0.5), minWidth: 0 }}>
        <Truncated as={FirstWordBoldText} size='medium'>
          {APPOINTMENT_INFO.personName || t('Unknown')}
        </Truncated>
        <div css={{ flex: 1, display: 'flex', gap: theme.spacing(0.5) }}>
          <div css={contentGridContainer}>
            <Truncated as={Text} size='small' color='subdued'>
              {APPOINTMENT_INFO.appointmentTime}
            </Truncated>
            <Truncated as={Text} size='small' color='subdued'>
              {APPOINTMENT_INFO.providerName}
            </Truncated>
            <div css={{ display: 'flex', gap: theme.spacing(0.5), alignItems: 'center', minWidth: 0 }}>
              <ColorDot size='small' color={APPOINTMENT_INFO.statusColor} />
              <Truncated as={Text} size='small' color='subdued'>
                {APPOINTMENT_INFO.appointmentType}
              </Truncated>
            </div>
            <Truncated as={Text} size='small' color='subdued'>
              {APPOINTMENT_INFO.operatoryName}
            </Truncated>
          </div>
          <div css={{ display: 'flex', gap: theme.spacing(0.5) }}>
            {/* // TODO: integrate appintment-status & verification status component */}
            <Chip size='tiny' css={{ gap: 0 }} leftElement={<Icon name='pending' size={12} />}></Chip>
            <Chip variant='active' size='tiny' css={{ gap: 0 }} leftElement={<Icon name='shield' size={12} />}></Chip>
          </div>
        </div>
      </div>
    </Component>
  );
};

const mainContainer = css({
  display: 'flex',
  gap: theme.spacing(1),
  padding: theme.spacing(1, 2),
});

const contentGridContainer = css({
  flex: 1,
  display: 'grid',
  gridTemplateColumns: 'repeat(2, auto)',
  columnGap: theme.spacing(1),
  rowGap: theme.spacing(0.5),
});
